import { map } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { MachineFamillyService } from '../shared/services/index';

@Pipe({
    name: 'productline',
    standalone: false
})
export class ProductLinePipe implements PipeTransform {
  constructor(private service: MachineFamillyService) {}

  transform(id: string): any {
    return this.service.getProductLineById(id).pipe(
      map((data: any) => {
        if (data) {
          return data.name;
        } else {
          return '';
        }
      })
    );
  }
}
